import { jsxs as r, jsx as l } from "react/jsx-runtime";
const e = (o) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m20.52 31.35 9.34-9.34-9.35-9.36-3.35.89 6.96 6.97H6l.8 3h17.32l-6.94 6.95 3.34.89Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M41.93 20.09V6l-19.24 5.37V12l4 4v-1.59l11.24-3.14V25.3l5.03-1.35 2.49-.66-6.9 21.86-2.51-7.39-1.2-3.54-3.62.97-4.53 1.21v-8.39l-4 4v9.6l9.56-2.56L38.7 58l12.76-40.46-9.53 2.55Z"
        }
      )
    ]
  }
);
export {
  e as PowerMove
};
